
import React, { useState, forwardRef } from "react";
import {
    uploadFileToStorage,
    saveWarrantyClaim,
  } from "../Utils/Utils";
import Swal from "sweetalert2";
import FileInput from "./MUI/FileInput";
import { motion, AnimatePresence } from "framer-motion";

const AfterSalesServiceSection = forwardRef((props, ref) => {
    const [uploadingFiles, setUploadingFiles] = useState(false);

    const [formData, setFormData] = useState({
      invoiceNumber: "",
      purchaseDate: "",
      productType: "",
      productName: "",
      phoneNumber: "",
      contactEmail: "",
      underWarranty: "",
      warrantyCertificate: null,
      invoiceFile: null,
      message: "",
    });

    const handleChange = (e) => {
      const { name, value, type, files } = e.target;
      setFormData({
        ...formData,
        [name]: type === "file" ? files[0] : value,
      });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setUploadingFiles(true);

      try {
        let warrantyUrl = null;
        let invoiceUrl = null;

        // Upload warrantyCertificate if present
        if (formData.warrantyCertificate) {
          warrantyUrl = await uploadFileToStorage(
            formData.warrantyCertificate,
            "warranty-certificates"
          );
        }

        // Upload invoiceFile if present
        if (formData.invoiceFile) {
          invoiceUrl = await uploadFileToStorage(
            formData.invoiceFile,
            "invoices"
          );

          setUploadingFiles(false);
        }

        // Save to Firebase DB
        await saveWarrantyClaim({
          ...formData,
          warrantyCertificate: warrantyUrl,
          invoiceFile: invoiceUrl,
        });

        Swal.fire({
          title: "Successs!",
          text: "Votre Reclamation a été enregisté avec succès",
          icon: "success",
          iconColor: "#fbf008",
          confirmButtonText: "OK",
          customClass: {
            container: "swall-container",
            confirmButton: "my-confirm-btn",
          },
        });

        // Optionally clear form
        setFormData({
          invoiceNumber: "",
          purchaseDate: "",
          productType: "",
          productName: "",
          phoneNumber: "",
          contactEmail: "",
          underWarranty: "",
          warrantyCertificate: null,
          invoiceFile: null,
          message: "",
        });
      } catch (err) {
        console.log("Submission failed:", err);
        Swal.fire({
          title: "Error!",
          text: "Failed to submit the form. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    return (
      <div
        ref={ref}
        id="after-sales-service"
        className="section after-sales-service w-full h-full flex-column justify-center px-80 box-sizing"
      >
        <p className="sec-text bold">Service Après-Vente</p>
        <p className="small-text w-1-2  my-20">
          Notre service après-vente est là pour vous accompagner en cas de
          besoin. Remplissez le formulaire ci-dessous avec les informations
          nécessaires pour que notre équipe puisse traiter votre demande
          rapidement et efficacement.
        </p>
        <form className="after-sales-form" onSubmit={handleSubmit}>
          <div className="input-container">
            <label>Numéro de facture :</label>
            <input
              type="text"
              name="invoiceNumber"
              placeholder="Saisissez le numéro de facture"
              value={formData.invoiceNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container">
            <label>Date d’achat :</label>
            <input
              type="date"
              name="purchaseDate"
              value={formData.purchaseDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container">
            <label>Type de produit :</label>
            <input
              type="text"
              name="productType"
              placeholder="Saisissez le type de produit"
              value={formData.productType}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container">
            <label>Nom du produit :</label>
            <input
              type="text"
              name="productName"
              placeholder="Saisissez le nom du produit"
              value={formData.productName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container">
            <label>Numéro de téléphone :</label>
            <input
              type="tel"
              name="phoneNumber"
              placeholder="Saisissez votre numéro de téléphone"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container">
            <label>E-mail de contact :</label>
            <input
              type="email"
              name="contactEmail"
              placeholder="Saisissez votre e-mail"
              value={formData.contactEmail}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-container">
            <label>Le produit est-il toujours sous garantie ? (Oui/Non)</label>
            <input
              type="text"
              name="underWarranty"
              placeholder="Oui / Non"
              value={formData.underWarranty}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-container">
            <label>Télécharger le certificat de garantie</label>
            <FileInput
              backgroundColor="#28a745"
              name="warrantyCertificate"
              value={formData.warrantyCertificate}
              onChange={handleChange}
            />
          </div>
          <div className="input-container">
            <label>Télécharger la facture</label>
            <FileInput
              backgroundColor="#28a745"
              name="invoiceFile"
              onChange={handleChange}
              value={formData.invoiceFile}
            />
          </div>

          <div className="input-container">
            <textarea
              placeholder="Veuillez Saisir Votre Message..."
              className="input my-20 py-10"
              onChange={handleChange}
              name="message"
              value={formData.message}
              draggable={false}
            />
          </div>

          <button
            type="submit"
            className="action-button sav-btn bg-red my-20  "
          >
            <motion.p
              className="btn absolute"
              initial={{ opacity: 0 }}
              animate={uploadingFiles ? { opacity: 1 } : { opacity: 0 }}
            >
              Importation...
            </motion.p>
            <motion.p
              className="btn"
              initial={{ opacity: 0 }}
              animate={!uploadingFiles ? { opacity: 1 } : { opacity: 0 }}
            >
              Envoyer
            </motion.p>
          </button>
        </form>
      </div>
    )

  });


 export default AfterSalesServiceSection;